export default {
  name: "dashboard-pm-card",
  components: {},
  props: [],
  data() {
    return {
      dashboardPMLoader: true
    };
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      this.dashboardPMLoader = false;
    }, 1000);
  },
  methods: {}
};
